/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconInputAi = createReactComponent("input-ai", "IconInputAi", [
  [
    "path",
    {
      d: "M20 11v-2a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h4",
      key: "svg-0"
    }
  ],
  ["path", { d: "M14 21v-4a2 2 0 1 1 4 0v4", key: "svg-1" }],
  ["path", { d: "M14 19h4", key: "svg-2" }],
  ["path", { d: "M21 15v6", key: "svg-3" }]
]);

export { IconInputAi as default };
//# sourceMappingURL=IconInputAi.js.map
